import React from 'react';
import PremiumSectionContainer from '../components/PremiumSectionContainer';
import PremiumSection from '../components/PremiumSection';
import { CustomerSection } from '../sections/CustomerSection';
import { PickupSection } from '../sections/PickupSection';
import { DropoffSection } from '../sections/DropoffSection';
import { LoadSection } from '../sections/LoadSection';
import { ServiceTypeSection } from '../sections/ServiceTypeSection';
import { ShipperSection } from '../sections/ShipperSection';

export const TicketFormBaseInputsBlock = (props) => {
  const { ticketFormBodyData } = props;
  return (
    <PremiumSectionContainer>
      <PremiumSection>
        <ShipperSection ticketFormBodyData={ticketFormBodyData} />
        <CustomerSection ticketFormBodyData={ticketFormBodyData} />
        <PickupSection ticketFormBodyData={ticketFormBodyData} />
        <DropoffSection ticketFormBodyData={ticketFormBodyData} />
        <LoadSection ticketFormBodyData={ticketFormBodyData} />
        <ServiceTypeSection ticketFormBodyData={ticketFormBodyData} />
      </PremiumSection>
    </PremiumSectionContainer>
  );
};
